import { TypedPublicApi } from "@novel/shared/typedPublicApi/TypedPublicRoutes";
import { currentScriptSrc } from "@vendor-storefront-global/tokenGating/utils/currentScriptSrc";
import { parse } from "qs";
export const hostFromCurrentScript = (() => {
    if (!currentScriptSrc) {
        return null;
    }
    try {
        return new URL(correctScriptSrc(currentScriptSrc)).host;
    }
    catch (e) {
        return null;
    }
})();
export const shopFromCurrentScript = (() => {
    var _a;
    if (!currentScriptSrc) {
        throw new Error("Unable to access Novel script src attribute");
    }
    try {
        const shopFromScript = (_a = parse(new URL(correctScriptSrc(currentScriptSrc)).search, {
            ignoreQueryPrefix: true,
        })) === null || _a === void 0 ? void 0 : _a.shop;
        if (typeof shopFromScript !== "string") {
            throw new Error('Loaded Novel script without "shop" query parameter provided, please provide .myshopify domain as "shop" query parameter');
        }
        return shopFromScript;
    }
    catch (e) {
        throw new Error(`Failed to parse scriptSrc: ${currentScriptSrc}`);
    }
})();
export const storefrontReq = new TypedPublicApi({
    shop: shopFromCurrentScript,
});
function correctScriptSrc(scriptSrc) {
    return scriptSrc.startsWith("//")
        ? `${window.location.protocol}${scriptSrc}`
        : scriptSrc.startsWith("/")
            ? `${window.location.origin}${scriptSrc}`
            : scriptSrc;
}
